import { useChatStore } from '@/stores/modules/chat'
window.addEventListener('message', async e => {
  let { data, source } = e

  if (source == window.parent) {
    const chatStore = useChatStore()
    // const { updataQuickComand } = chatStore
    let type = data.type

    switch (type) {
      case 'onPreview': {
        break
      }
      // case "updataQuickComand": {
      //   updataQuickComand(data.data)
      //   break;
      // }
    }
  }
})
